// Contact横の矢印が上を向き、画面外へ飛び出した後にページを引き上げる。
export function initFooterReturn(footer, lenis) {
  const document = footer.ownerDocument;
  const view = document.defaultView;
  const link = footer.querySelector('.back-to-top');
  const arrow = footer.querySelector('.footer-contact-arrow');
  let phase = null;
  let timer = 0;
  let sequence = 0;
  const cleanups = [];
  const listen = (element, type, callback) => {
    element.addEventListener(type, callback);
    cleanups.push(() => element.removeEventListener(type, callback));
  };
  const clearTimer = () => {
    view.clearTimeout(timer);
    timer = 0;
  };
  const reset = () => {
    sequence++;
    phase = null;
    clearTimer();
    footer.classList.remove('is-returning-top', 'is-top-arrow-flying');
  };
  const cancel = () => {
    if (!phase) return;
    reset();
    lenis.stop();
    lenis.start();
  };
  const scroll = () => {
    if (phase !== 'flying') return;
    clearTimer();
    phase = 'scrolling';
    const run = sequence;
    lenis.start();
    lenis.scrollTo(0, {
      duration: .9,
      lerp: 0,
      easing: (t) => t < .5 ? 16 * t ** 5 : 1 - (-2 * t + 2) ** 5 / 2,
      lock: true,
      onComplete: () => {
        if (phase !== 'scrolling' || sequence !== run) return;
        view.history.replaceState(null, '', '#top');
        reset();
      },
    });
  };
  const launch = () => {
    if (phase !== 'turning') return;
    clearTimer();
    phase = 'flying';
    footer.classList.add('is-top-arrow-flying');
    // 完了通知が届かない場合にも、トップへ戻る操作を止めない。
    timer = view.setTimeout(scroll, 650);
  };
  listen(link, 'click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    // 共通アンカーと標準ジャンプより先に、矢印の演出を完了させる。
    event.stopPropagation();
    if (phase) return;
    phase = 'turning';
    lenis.stop();
    footer.classList.add('is-returning-top');
    // ホバーですでに上を向いている場合はtransitionendが来ない。
    timer = view.setTimeout(launch, 350);
  });
  listen(arrow, 'transitionend', (event) => {
    if (event.target === arrow && event.propertyName === 'transform') launch();
  });
  const onFlightEnd = (event) => {
    if (event.target === arrow && event.animationName === 'footer_top_launch') scroll();
  };
  listen(arrow, 'animationend', onFlightEnd);
  listen(arrow, 'animationcancel', onFlightEnd);
  listen(document, 'visibilitychange', () => { if (document.hidden) cancel(); });
  listen(view, 'pagehide', cancel);
  return {
    cancel,
    destroy() {
      cleanups.forEach((cleanup) => cleanup());
      cancel();
    },
  };
}
